// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgWhiteGoodsIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M16 14c0 2.21-1.79 4-4 4s-4-1.79-4-4 1.79-4 4-4 4 1.79 4 4m4-10v16c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2M9 5c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1M6 5c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1m12 9c0-3.31-2.69-6-6-6s-6 2.69-6 6 2.69 6 6 6 6-2.69 6-6m0-10h-3v2h3z" />
  </g>
);
export default SvgWhiteGoodsIcon;
SvgWhiteGoodsIcon.displayName = 'SvgWhiteGoodsIcon';
